export default __webpack_public_path__ + "static/media/nelloOp2.fc92c0fe.png";